import { Outlet } from "react-router-dom";

const BookingManagementOutlet = () => {
  return <Outlet />;
};

export { BookingManagementOutlet };
